import React from 'react';
import { Phone, HelpCircle, CheckCircle, ArrowRight, FileText, AlertCircle } from 'lucide-react';
export function WhatElseDoINeedToKnowPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4273">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4274">
        <div className="container mx-auto px-4" data-id="element-4275">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4276">
            What Else Do I Need to Know?
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4277">
            Additional CDL Requirements & Information
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4278">
        <div className="max-w-4xl mx-auto" data-id="element-4279">
          {/* Do I Need a Chauffeur License? */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4280">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4281">
              <HelpCircle className="mr-3 text-[#B1050B]" size={28} data-id="element-4282" />
              Do I Need a Chauffeur License?
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4283">
              <p className="text-gray-800 mb-4 font-semibold" data-id="element-4284">
                A chauffeur base license is required when a person is:
              </p>
            </div>

            <div className="space-y-4" data-id="element-4285">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-4286">
                <div className="flex items-start" data-id="element-4287">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4288" />
                  <p className="text-gray-700" data-id="element-4289">
                    <strong data-id="element-4290">Employed for the principal purpose</strong> of
                    operating a motor vehicle or combination of vehicles with a
                    GVWR or GCWR or GVW or GCW of{' '}
                    <strong data-id="element-4291">10,000 pounds or more</strong>
                  </p>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-4292">
                <div className="flex items-start" data-id="element-4293">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4294" />
                  <p className="text-gray-700" data-id="element-4295">
                    Operating a motor vehicle as a{' '}
                    <strong data-id="element-4296">carrier of passengers</strong> or as a{' '}
                    <strong data-id="element-4297">common or contract carrier of property</strong>
                  </p>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-4298">
                <div className="flex items-start" data-id="element-4299">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4300" />
                  <p className="text-gray-700" data-id="element-4301">
                    Operating a{' '}
                    <strong data-id="element-4302">bus, school bus, taxi or limousine</strong>
                  </p>
                </div>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6" data-id="element-4303">
                <div className="flex items-start" data-id="element-4304">
                  <AlertCircle className="text-yellow-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4305" />
                  <div data-id="element-4306">
                    <p className="text-gray-800 mb-2" data-id="element-4307">
                      <strong data-id="element-4308">Important Medical Requirement:</strong>
                    </p>
                    <p className="text-gray-700" data-id="element-4309">
                      Drivers operating vehicles singly or in combination with a
                      GVW, GVWR, GCW or GCWR of{' '}
                      <strong data-id="element-4310">10,000 pounds or more</strong> must meet the{' '}
                      <strong data-id="element-4311">commercial driver medical requirements</strong>{' '}
                      (including possession of the appropriate medical card or
                      medical waiver).
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-4312">
                <p className="text-gray-700" data-id="element-4313">
                  If required, the{' '}
                  <strong data-id="element-4314">CDL group designator and CDL endorsements</strong> are
                  added to the chauffeur base license.
                </p>
              </div>
            </div>
          </div>

          {/* Converting Out-of-State CDL */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4315">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4316">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-4317" />
              Converting Out-of-State CDL to Michigan CDL
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4318">
              <p className="text-gray-800" data-id="element-4319">
                When moving to Michigan from another state, you must apply for a
                Michigan CDL to operate commercial vehicles. To obtain a
                Michigan CDL, you must visit a Secretary of State branch office
                and:
              </p>
            </div>

            <div className="space-y-4" data-id="element-4320">
              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4321">
                <div className="flex items-start" data-id="element-4322">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4323">
                    1
                  </div>
                  <div data-id="element-4324">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4325">
                      Surrender Your Out-of-State CDL
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4326">
                      You must turn in your current out-of-state CDL
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4327">
                <div className="flex items-start" data-id="element-4328">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4329">
                    2
                  </div>
                  <div data-id="element-4330">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4331">
                      Complete Computer Check
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4332">
                      Eligibility status check through national and state
                      records
                    </p>
                    <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-4333">
                      <p className="text-sm text-gray-800" data-id="element-4334">
                        <strong data-id="element-4335">Important:</strong> If your driving privilege is
                        suspended, revoked, denied or cancelled for any reason
                        in any other state, you{' '}
                        <strong data-id="element-4336">cannot receive your Michigan CDL</strong> until
                        the out-of-state licensing issue(s) are resolved. The
                        driving record check must be completed by the branch
                        office before your CDL can be issued.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4337">
                <div className="flex items-start" data-id="element-4338">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4339">
                    3
                  </div>
                  <div data-id="element-4340">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4341">
                      Pass the Vision Test
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4342">
                      Required for all CDL applicants
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4343">
                <div className="flex items-start" data-id="element-4344">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4345">
                    4
                  </div>
                  <div data-id="element-4346">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4347">
                      Take Michigan CDL Written Tests (If Required)
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4348">
                      Required if you are:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700" data-id="element-4349">
                      <li className="flex items-start" data-id="element-4350">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4351" />
                        <span data-id="element-4352">Upgrading your group designator</span>
                      </li>
                      <li className="flex items-start" data-id="element-4353">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4354" />
                        <span data-id="element-4355">Adding endorsements</span>
                      </li>
                      <li className="flex items-start" data-id="element-4356">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4357" />
                        <span data-id="element-4358">Removing an air brake restriction</span>
                      </li>
                    </ul>
                    <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-4359">
                      <p className="text-sm text-gray-800" data-id="element-4360">
                        <strong data-id="element-4361">Note:</strong> To keep your{' '}
                        <strong data-id="element-4362">H-Hazardous Materials endorsement</strong>, you
                        must <strong data-id="element-4363">always</strong> take and pass the Hazmat
                        written test. Otherwise, written tests are not required
                        if you are not upgrading your CDL.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4364">
                <div className="flex items-start" data-id="element-4365">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4366">
                    5
                  </div>
                  <div data-id="element-4367">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4368">
                      Take Michigan CDL Skills Test (If Required)
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4369">
                      Required if you are:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700 mb-4" data-id="element-4370">
                      <li className="flex items-start" data-id="element-4371">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4372" />
                        <span data-id="element-4373">Upgrading your group designator</span>
                      </li>
                      <li className="flex items-start" data-id="element-4374">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4375" />
                        <span data-id="element-4376">Adding the P-Passenger endorsement</span>
                      </li>
                      <li className="flex items-start" data-id="element-4377">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4378" />
                        <span data-id="element-4379">
                          Removing a CDL limitation (such as air brake
                          restriction)
                        </span>
                      </li>
                    </ul>
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4380">
                      <p className="text-sm text-gray-800 mb-2" data-id="element-4381">
                        <strong data-id="element-4382">Important Timing:</strong>
                      </p>
                      <p className="text-sm text-gray-700" data-id="element-4383">
                        If a CDL skills test is required, you must{' '}
                        <strong data-id="element-4384">
                          wait until you receive your photo Michigan base
                          license
                        </strong>{' '}
                        (operator or chauffeur) to take the test. Your Michigan
                        photo driver license must be presented to the third
                        party driver skills test organization before your CDL
                        skills test can be administered. Generally, your regular
                        driver license (operator or chauffeur) will be{' '}
                        <strong data-id="element-4385">mailed to you within ten (10) days</strong>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-green-500 rounded-lg p-6" data-id="element-4386">
                <div className="flex items-start" data-id="element-4387">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4388">
                    6
                  </div>
                  <div data-id="element-4389">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4390">
                      Receive Your Michigan CDL
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4391">
                      Upon proper and successful completion of any necessary CDL
                      tests and payment of fees
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Incidental Drivers */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4392">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4393">
              <HelpCircle className="mr-3 text-[#B1050B]" size={28} data-id="element-4394" />
              Do "Incidental" Drivers Need a CDL?
            </h2>

            <div className="bg-red-50 border-2 border-red-500 rounded-lg p-6" data-id="element-4395">
              <div className="flex items-start" data-id="element-4396">
                <AlertCircle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-4397" />
                <div data-id="element-4398">
                  <p className="text-gray-800 font-semibold mb-3" data-id="element-4399">
                    Unless exempt, any driver who operates a commercial motor
                    vehicle on roads or highways that are accessible to the
                    public, <strong data-id="element-4400">must have a CDL</strong> regardless of:
                  </p>
                  <ul className="space-y-2 text-gray-700" data-id="element-4401">
                    <li className="flex items-start" data-id="element-4402">
                      <span className="text-red-600 mr-2" data-id="element-4403">•</span>
                      <span data-id="element-4404">The distance driven</span>
                    </li>
                    <li className="flex items-start" data-id="element-4405">
                      <span className="text-red-600 mr-2" data-id="element-4406">•</span>
                      <span data-id="element-4407">Amount of driving time</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-lg p-6 mt-6" data-id="element-4408">
              <p className="text-gray-700" data-id="element-4409">
                <strong data-id="element-4410">Bottom line:</strong> If you operate a CMV on public
                roads or highways, you need a CDL - even if it's only
                occasionally or for short distances.
              </p>
            </div>
          </div>

          {/* Quick Reference Summary */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-4411">
            <h2 className="text-3xl font-bold mb-6" data-id="element-4412">Quick Reference</h2>

            <div className="space-y-6" data-id="element-4413">
              <div data-id="element-4414">
                <h3 className="text-xl font-bold mb-3" data-id="element-4415">
                  Chauffeur License Required For:
                </h3>
                <ul className="space-y-2 text-sm" data-id="element-4416">
                  <li data-id="element-4417">• Employed to operate vehicles ≥10,000 lbs</li>
                  <li data-id="element-4418">• Carrier of passengers or property</li>
                  <li data-id="element-4419">• Bus, school bus, taxi, or limousine</li>
                  <li data-id="element-4420">• Medical card required for 10,000+ lbs vehicles</li>
                </ul>
              </div>

              <div data-id="element-4421">
                <h3 className="text-xl font-bold mb-3" data-id="element-4422">
                  Out-of-State CDL Conversion (6 Steps):
                </h3>
                <ul className="space-y-2 text-sm" data-id="element-4423">
                  <li data-id="element-4424">1. Surrender out-of-state CDL</li>
                  <li data-id="element-4425">2. Complete computer eligibility check</li>
                  <li data-id="element-4426">3. Pass vision test</li>
                  <li data-id="element-4427">
                    4. Take written tests (if upgrading/adding endorsements)
                  </li>
                  <li data-id="element-4428">
                    5. Take skills test (if upgrading/adding P endorsement)
                  </li>
                  <li data-id="element-4429">6. Receive Michigan CDL upon completion</li>
                </ul>
              </div>

              <div data-id="element-4430">
                <h3 className="text-xl font-bold mb-3" data-id="element-4431">Incidental Drivers:</h3>
                <p className="text-sm" data-id="element-4432">
                  CDL required for ANY CMV operation on public roads -
                  regardless of distance or time
                </p>
              </div>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-4433">
            <h2 className="text-3xl font-bold mb-6" data-id="element-4434">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-4435">
              <div className="flex items-start" data-id="element-4436">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4437" />
                <span data-id="element-4438">
                  Chauffeur license required for vehicles ≥10,000 lbs, passenger
                  carriers, buses, taxis, limos
                </span>
              </div>
              <div className="flex items-start" data-id="element-4439">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4440" />
                <span data-id="element-4441">Medical card required for 10,000+ lbs vehicles</span>
              </div>
              <div className="flex items-start" data-id="element-4442">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4443" />
                <span data-id="element-4444">
                  Out-of-state CDL must be surrendered when converting to
                  Michigan
                </span>
              </div>
              <div className="flex items-start" data-id="element-4445">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4446" />
                <span data-id="element-4447">
                  Cannot receive Michigan CDL if suspended/revoked in another
                  state
                </span>
              </div>
              <div className="flex items-start" data-id="element-4448">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4449" />
                <span data-id="element-4450">Hazmat endorsement always requires written test</span>
              </div>
              <div className="flex items-start" data-id="element-4451">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4452" />
                <span data-id="element-4453">
                  Skills test requires waiting for photo Michigan base license
                  (10 days)
                </span>
              </div>
              <div className="flex items-start" data-id="element-4454">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4455" />
                <span data-id="element-4456">
                  Incidental drivers need CDL regardless of distance or time
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4457">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4458">
              Have More Questions About CDL Requirements?
            </h2>
            <p className="text-xl mb-6" data-id="element-4459">
              Expert guidance on chauffeur licenses, CDL conversion, and
              compliance
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4460">
              <Phone className="mr-3" size={24} data-id="element-4461" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4462">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}